export { BvlSelectComponent as BvlSelect } from './select.component';
export { BvlSelectModule } from './select.module';
